import React, { MutableRefObject, useEffect, useState } from 'react';
import { TextInput, TextInputProps, View } from 'react-native';
import { useTheme } from 'Theme';
import Icon from '../Icon';

import styles from './InputWithIconButton.jss';

interface InputWithIconButtonProps extends TextInputProps {
    onSecureIconPress?: React.Dispatch<React.SetStateAction<boolean>>,
    setRef?: MutableRefObject<TextInput>,
    showIcon?: boolean,
    showText?: boolean,
    onIconPress?: React.Dispatch<React.SetStateAction<boolean>>
    buttonIcon?: boolean,
    loginWasPressed?: boolean,
}

const InputWithIconButton = ({ style, showIcon = false, showText = false,
    onSecureIconPress, setRef, onIconPress, buttonIcon = false, loginWasPressed, ...restProps }: InputWithIconButtonProps) => {
    const { regularFont } = useTheme();
    const [showTextState, setShowTextState] = useState(showText);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        setShowTextState(showText);
    }, [showText]);

    const onSecureIconPressed = () => {
        const newState = !showTextState;
        setShowTextState(newState);
        onSecureIconPress?.(newState);
    };


    const icon = buttonIcon
        ? 'infoCircleColor'
        : showTextState
            ? 'password_visible'
            : 'password_invisible';

    const secureState = isFocused && !loginWasPressed ? !showTextState : false

    return (
        <View style={styles.container}>
            <TextInput
                ref={setRef}
                {...restProps}
                style={[styles.input, { fontFamily: regularFont }, style]}
                secureTextEntry={loginWasPressed ? !showTextState : secureState}
                autoCapitalize="none"
                textContentType="none"
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
            {showIcon && (
                <View style={styles.switchContainer}>
                    <Icon
                        name={icon}
                        style={buttonIcon ? styles.info : styles.switch}
                        onPress={onIconPress ? onIconPress : onSecureIconPressed}
                        testID="input_button_icon"
                    />
                </View>
            )}
        </View>
    );
};

export default InputWithIconButton;

